import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function DetailCommunityModal({ isOpen, onClose, community }) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={()=>{}}>
        <div className="fixed inset-0 bg-black/50 flex items-center justify-end pr-[10%] pt-6 z-50">
          <div className="bg-white w-[calc(85vh*1)] h-[85vh] rounded-lg shadow-xl">
            {/* Black header */}
            <div className="bg-black text-white px-4 py-3 rounded-t-lg">
              <h2 className="text-lg font-semibold">
                Community Details
              </h2>
            </div>

            {/* White content area */}
            <div className="p-4 h-[calc(85vh-116px)] overflow-y-auto">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-1">Community ID</label>
                  <input
                    type="text"
                    value={community?.communityId || ''}
                    disabled
                    className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-50"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">Community Name</label>
                  <input
                    type="text"
                    value={community?.communityName || ''}
                    disabled
                    className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-50"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">Community Address</label>
                  <input
                    type="text"
                    value={community?.communityAddress || ''}
                    disabled
                    className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-50"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">longitude</label>
                  <input
                    type="text"
                    value={community?.longitude || ''}
                    disabled
                    className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-50"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">latitude</label>
                  <input
                    type="text"
                    value={community?.latitude || ''}
                    disabled
                    className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-50"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">Service Range(Meters)</label>
                  <input
                    type="text"
                    value={community?.serviceRange || ''}
                    disabled
                    className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-50"
                  />
                </div>

                <div className="flex gap-4">
                  <div className="flex-1">
                    <label className="block text-sm font-medium mb-1">Contacts</label>
                    <input
                      type="text"
                      value={community?.contacts || ''}
                      disabled
                      className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-50"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm font-medium mb-1">Contacts Phone</label>
                    <input
                      type="text"
                      value={community?.contactsPhone || ''}
                      disabled
                      className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-50"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm font-medium mb-1">Email</label>
                    <input
                      type="email"
                      value={community?.email || ''}
                      disabled
                      className="w-full border border-gray-300 rounded px-3 py-2 bg-gray-50"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Footer with close button */}
            <div className="px-4 py-3 border-t border-gray-200">
              <div className="flex justify-end">
                <button
                  onClick={onClose}
                  className="px-4 py-1.5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}